// const pathLength = 2329;
const rosePathLength = 294;

const butterflyPathStart = 296;
const butterflyPathLength = 258;

const snakePathStart = 556;
const snakePathLength = 466;

const dolphinPathStart = 1024;
const dolphinPathLength = 509;

const houndPathStart = 1535;
const houndPathLength = 428;

const pilgrimPathStart = 1965;
const pilgrimPathLength = 370;

export const lessons = [
  {
    id: "intro",
    possOnPath: 0,
    subPathLength: 0,
    colour: "#97743b",
    showFullLabyrinth: true,
    bounds: { x: 24, y: 63, w: 114, h: 118 },
    title: "Introduction",
    number: 0,
    lesson:
      "This interactive section gives you the opportunity to see where and how each of the illustrations for the different lessons appears within the overall form of the labyrinth. <br/> The movement of the thread can be followed to the centre and back again, or you can just click on the individual numbers to see their position and corresponding lesson. <br/> Further information about each one and the project as a whole can be found in the full Lessons from the Labyrinth document.",
  },
  {
    id: "rose",
    possOnPath: 0,
    subPathLength: rosePathLength,
    colour: "#e33434",
    showRose: true,
    bounds: { x: 24, y: 63, w: 114, h: 118 },
    // bounds: { x: 42, y: 103, w: 60, h: 78 },
    title: "The Labyrinth Rose",
    subtitle: "Experiencing Beauty",
    number: 1,
    lesson:
      "Choosing to focus on noticing the beauty we come across, and taking the time to engage with it in some way, can help us to cultivate positive states of being.",
  },
  {
    id: "butterfly",
    possOnPath: butterflyPathStart,
    subPathLength: butterflyPathLength,
    colour: "#ed9817",
    showButterfly: true,
    bounds: { x: 24, y: 63, w: 114, h: 118 },
    title: "The Thought Butterfly",
    subtitle: "Forming an Intention",
    number: 2,
    lesson:
      "The process of forming the right intentions in our approach to our lives and to those around us is an essential one, that hopefully allows our actions to come from a place of kindness and thought, even if the end result proves to be not quite what we envisioned!",
  },
  {
    id: "snake",
    possOnPath: snakePathStart,
    subPathLength: snakePathLength,
    // colour: "#fbd64e",
    colour: "#FFD700",
    showSnake: true,
    bounds: { x: 16, y: 65, w: 122, h: 122 },
    title: "The Story Snake",
    subtitle: "Making Connections",
    number: 3,
    lesson:
      "The labyrinth shows us how the mere act of walking around a place can lead to many meaningful interactions, and by discovering and making connections we can develop a real sense of belonging. <br/> The twists and turns of its pathway are also an appropriate metaphor for our own life's meandering journey with all its changes of direction, ups and downs, sadness and joy. <br/> So walking the labyrinth can re-connect us to our own story and our own sense of being too.",
  },
  {
    id: "dolphin",
    possOnPath: dolphinPathStart,
    subPathLength: dolphinPathLength,
    colour: "#008000",
    showDolphin: true,
    bounds: { x: 12, y: 58, w: 127, h: 125 },
    title: "The Joyful Dolphin",
    subtitle: "Tuning In",
    number: 4,
    lesson:
      "Taking moments to tune in throughout our day to the sensations of our inner and outer physical environments can help us to find an aware, but relaxed mental space. <br/> This can connect us to the joyful state of just being in the moment and in doing so give us a rest from any stressful thoughts or feelings we may be experiencing.",
  },
  {
    id: "hound",
    possOnPath: houndPathStart,
    subPathLength: houndPathLength,
    colour: "#076fff",
    showHound: true,
    bounds: { x: 24, y: 63, w: 114, h: 118 },
    title: "The Faithful Hound",
    subtitle: "Trusting the Pathway",
    number: 5,
    lesson:
      "We can use our experiences of trust gained whilst walking the labyrinth to guide us in our lives when we feel lost, worried about the way ahead, feeling like we are going round in circles or need to make a change in direction. <br/> It reminds us to focus on the journey itself and reassures us that we are making progress even when we can't see a destination. <br/> The labyrinth offers us the determination to keep going and the hope that we will get there, wherever there might be!",
  },
  {
    id: "pilgrim",
    possOnPath: pilgrimPathStart,
    subPathLength: pilgrimPathLength,
    colour: "#9c27b0",
    showPilgrim: true,
    bounds: { x: 24, y: 63, w: 116, h: 118 },
    title: "The Praying Pilgrim",
    subtitle: "Being Open",
    number: 6,
    lesson:
      "Bringing this sense of openness and flexibility back from our labyrinth walk and into our everyday lives, can reduce stress by releasing us from closed mindsets where we feel that something has to happen in a certain way. <br/> A more open approach to life can lead to many surprising and rewarding experiences, sometimes in ways in which we never could have imagined!",
  },
  {
    id: "whole",
    showCenterDisc: true,
    possOnPath: 2322,
    subPathLength: 3,
    colour: "#97743b",
    showBody: true,
    showFullLabyrinth: true,
    bounds: { x: 0, y: 0, w: 159, h: 214 },
    title: "Finding Ourselves",
    subtitle: "Feeling Whole",
    number: 7,
    lesson:
      "The labyrinth reminds us that there is always a still and whole centre within ourselves even at the most difficult and turbulent of times. When we reach it, we can return to face the world with a new strength and a new understanding.",
  },
];

export const getLessonColours = () => {
  const colourObj = {};
  for (let l of lessons) {
    colourObj[l.id] = l.colour;
  }
  return colourObj;
};

// const intro = {
//   title: "Lessons from the Labyrinth - Introduction",
//   number: 0,
//   lesson:
//     "During a period of transition in my life in 2015 I became fascinated with labyrinths and was drawn to find out more about them. Inspired by my learning and reflecting on my experiences with a nearby labyrinth, I found creative thoughts and ideas began to pour out of me, to repeat a quote I came across, “..the work flowed and unwound like the pathway of a labyrinth.” - This book is the culmination of all this energy and expression.",
// };

// {
//   title: "",
//   number: 999,
//   lesson: "",
// },
